/* React Components */
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
/* Providers */
import { useAuth } from '../../context/AuthContext';
/* React Icons */
import { MdAddLink, MdContentCopy, MdCheckCircle } from "react-icons/md";

const CategoryQuestGenerator = () => {
    /* User Information */
    const { commonCategoryList } = useAuth();

    // State variables
    const [question, setQuestion] = useState('');
    const [selectedCategory, setSelectedCategory] = useState('');
    const [generatedUrl, setGeneratedUrl] = useState('');
    const [copySuccess, setCopySuccess] = useState('');
    const [categoryLists, setCategoryLists] = useState([]);

    useEffect(() => {
        async function initializeAuth() {
            const catLists = await commonCategoryList();
            setCategoryLists(catLists);
            setSelectedCategory(catLists[0].slug);
        }
        initializeAuth();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Function to generate the URL
    const generateUrl = () => {
        if (!question.trim()) {
            alert('Please enter a question');
            return;
        }

        // Encode the question for URL safety
        const encodedQuestion = encodeURIComponent(question.trim());
        const url = `https://ari-ai.vercel.app/category/${selectedCategory}?question=${encodedQuestion}`;
        setGeneratedUrl(url);
        setCopySuccess('');
    };

    // Function to copy URL to clipboard
    const copyToClipboard = async () => {
        if (!generatedUrl) {
            alert('Please generate a URL first');
            return;
        }

        try {
            await navigator.clipboard.writeText(generatedUrl);
            setCopySuccess(`Copied Successfully!`);
            setTimeout(() => setCopySuccess(''), 2000);
        } catch (err) {
            alert('Failed to copy');
            setTimeout(() => setCopySuccess(''), 2000);
        }
    };
    
    return (
        <section className={`chat-body-container admin-section-container ari-theme`}>
            <div className="admin-dashboard-content">
                <div className="chat-box-top-container">
                    <a href="/admin/dashboard" className='chat-heading-container'>
                        <span>Category Question Generator</span>
                    </a>
                </div>
                
                {/* Admin Details */}
                <div className={`dbmm-dashboard-container ari-theme`}>
                    <div className="dbmm-dashboard-grid">
                        <div className="mm-row">
                            <div className="mm-col-xs-12 mm-col-md-12 mm-col-lg-12">
                                <div className="dbmm-latest-users-container">
                                    <div className="dbmm-admin-section-title">
                                        <h3>Category Question Generator</h3>
                                        <ul className="breadcrumbs">
                                            <li>
                                                <Link to={`/`}>Home </Link>
                                            </li>
                                            <li>
                                                <span className="active">Category Question Generator</span>
                                            </li>
                                        </ul>
                                    </div>

                                    {/* Question Link Generator */}
                                    <div className="question-generator-wrapper">
                                        <div className="qgw-container-form">
                                            {/* Question Input Field */}
                                            <div className="qgw-form-group question-grp">
                                                <label className="qgw-label" htmlFor="questionInput"> Question: </label>
                                                <input id="questionInput" type="text" className="qgw-input" placeholder="e.g., what is peer?" value={question} onChange={(e) => setQuestion(e.target.value)} />
                                            </div>

                                            {/* Category Dropdown */}
                                            <div className="qgw-form-group category-grp">
                                                <label className="qgw-label" htmlFor="categorySelect"> Category: </label>
                                                <select id="categorySelect" className="qgw-select" value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)}>
                                                    {categoryLists.map((cat) => (
                                                        <option key={cat.id} value={cat.slug}> {cat.category_name} </option>
                                                    ))}
                                                </select>
                                            </div>

                                            {/* Generate Button */}
                                            <div className="qgw-button-group">
                                                <button className="qgw-generate-btn" onClick={generateUrl}> <MdAddLink /> Generate Link </button>
                                            </div>
                                        </div>

                                        {/* URL Output Section - only shown if URL exists */}
                                        {generatedUrl && (
                                            <div className="qgw-url-section">
                                                <label className="qgw-label">Generated URL:</label>
                                                <div className="qgw-url-wrapper">
                                                    <input type="text" className="qgw-url-input" value={generatedUrl} readOnly/>
                                                    <button className="qgw-copy-btn" onClick={copyToClipboard}><MdContentCopy /> Copy URL </button>
                                                </div>
                                                {copySuccess && (
                                                    <span className="qgw-copy-status"><MdCheckCircle />  {copySuccess}</span>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CategoryQuestGenerator;